import gql from 'graphql-tag';

export default gql`
mutation createCourseLearningNote($create: LearningNoteCreateInput!) {
  createCourseLearningNote(create: $create) {
      id
    }
  }
`;
